import { Link, Outlet, useLocation } from "react-router-dom";
import { Building2, Clock, CalendarCog, Code2, ArrowLeft, UserCog, ClipboardList, CreditCard, Store, Puzzle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const settingsCategories = [
  {
    to: "/dashboard/settings/profile",
    icon: UserCog,
    titleKey: "settings.profile",
    descKey: "settings.profile_desc",
  },
  {
    to: "/dashboard/settings/organisation",
    icon: Building2,
    titleKey: "settings.organisation",
    descKey: "settings.organisation_desc",
  },
  {
    to: "/dashboard/settings/shop",
    icon: Store,
    titleKey: "settings.shop",
    descKey: "settings.shop_desc",
  },
  {
    to: "/dashboard/settings/opening-hours",
    icon: Clock,
    titleKey: "settings.opening_hours",
    descKey: "settings.opening_hours_desc",
  },
  {
    to: "/dashboard/settings/booking",
    icon: CalendarCog,
    titleKey: "settings.booking",
    descKey: "settings.booking_desc",
  },
  {
    to: "/dashboard/settings/checkout",
    icon: ClipboardList,
    titleKey: "settings.checkout",
    descKey: "settings.checkout_desc",
  },
  {
    to: "/dashboard/settings/embed",
    icon: Code2,
    titleKey: "settings.embed",
    descKey: "settings.embed_desc",
  },
  {
    to: "/dashboard/settings/billing",
    icon: CreditCard,
    titleKey: "settings.billing",
    descKey: "settings.billing_desc",
  },
  {
    to: "/dashboard/settings/extensions",
    icon: Puzzle,
    titleKey: "settings.extensions",
    descKey: "settings.extensions_desc",
  },
];

const SettingsPage = () => {
  const location = useLocation();
  const isRoot = location.pathname === "/dashboard/settings";
  const { t } = useLanguage();

  if (!isRoot) {
    return (
      <div className="p-6">
        <Button variant="ghost" size="sm" asChild className="mb-4 -ml-2 text-muted-foreground">
          <Link to="/dashboard/settings">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t("settings.back")}
          </Link>
        </Button>
        <Outlet />
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold text-foreground mb-6">{t("settings.title")}</h1>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {settingsCategories.map((cat) => (
          <Link
            key={cat.to}
            to={cat.to}
            className="group rounded-xl border border-border bg-card p-5 shadow-card transition-all hover:border-primary/30 hover:shadow-md"
          >
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
              <cat.icon className="h-5 w-5" />
            </div>
            <h2 className="text-sm font-semibold text-card-foreground">{t(cat.titleKey)}</h2>
            <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{t(cat.descKey)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SettingsPage;
